const preloader = document.getElementById('preloader');
if (preloader) {
  const hide = () => {
    const duration = (preloader.dataset.duration || 2) * 1000;

    setTimeout(() => {
      preloader.style.transition = 'opacity 1s';
      preloader.style.opacity = '0';
      // Stop swallowing clicks the moment the fade starts, not only once
      // display:none lands — if the tab is backgrounded, browsers throttle
      // timers, so the display:none step below can be delayed indefinitely
      // while this element (position:fixed, full-viewport, z-index:9999)
      // keeps capturing every click on the page underneath it.
      preloader.style.pointerEvents = 'none';

      setTimeout(() => {
        preloader.style.display = 'none';
      }, 1000); // Wait for transition to complete
    }, duration);
  };

  // Use DOMContentLoaded instead of window's load event — load waits for
  // every resource on the page, including the hero's background video.
  // If that video is slow or fails to resolve, load never fires and this
  // preloader never starts hiding itself, leaving a full-screen overlay
  // blocking clicks indefinitely even though the real page content behind
  // it has already rendered.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hide);
  } else {
    hide();
  }
}
